import { DateTime } from "luxon";

import type { InboxChat } from "context/ChatUnreadContext";

const PUBNUB_TIME_TOKEN_TO_MS_DIVISOR = 10_000;
// Backend sentinel for "no real time token" (chat.constants.PUBNUB_BEGINNING_OF_TIME_TOKEN).
// Used for inbox rows where PubNub returned no preview message.
const PUBNUB_BEGINNING_OF_TIME_TOKEN = "1";

/**
 * Converts a 17-digit PubNub time token (100ns ticks since epoch) to a short
 * relative-time label like "just now" / "5 min ago" / "2 hr ago" / "3 days ago".
 *
 * Falls back to an empty string for malformed input or the
 * beginning-of-time sentinel rather than throwing, since the time token
 * is read from external (PubNub) data.
 */
export function pubnubTimeTokenToRelative(timeToken: string): string {
  if (timeToken === PUBNUB_BEGINNING_OF_TIME_TOKEN) return "";
  const numeric = Number(timeToken);
  if (!Number.isFinite(numeric) || numeric <= 0) return "";
  const millis = numeric / PUBNUB_TIME_TOKEN_TO_MS_DIVISOR;
  const dt = DateTime.fromMillis(millis);
  if (!dt.isValid) return "";
  return dt.toRelative({ style: "short" }) ?? "";
}

export function filterInboxRowsByQuery(
  rows: InboxChat[],
  rawQuery: string,
): InboxChat[] {
  const query = rawQuery.toLowerCase().trim();
  if (query.length === 0) return rows;
  return rows.filter(
    (row) =>
      String(row.shipment_id).toLowerCase().includes(query) ||
      row.shipment_label.toLowerCase().includes(query) ||
      row.latest_message_sender_name.toLowerCase().includes(query) ||
      row.latest_message_preview.toLowerCase().includes(query) ||
      (row.counterparty_company_name ?? "").toLowerCase().includes(query),
  );
}
